module.exports = __webpack_public_path__ + "media/PAG70-03.b0b8a244.mp3";